import { APIClient } from "@frontend/api-utils";
import { DomainSetting } from "@frontend/setting/types";

export class DomainSettingClient extends APIClient {
    public static readonly endpoint = '/setting-api/v1';

    public static async fetchDomain(): Promise<DomainSetting> {
        const response = await this.fetch(`${this.endpoint}/domain-settings`);
        return await this.handleResponse<DomainSetting>(response);
    }
}